window.moment = require("moment");
window.humanizeDuration = require('humanize-duration');
window.Pusher = require('pusher-js');
require('chart.js');
require('angular-chart.js');
window.zxcvbn = require('zxcvbn');

import Echo from "laravel-echo";

let echoKey = document.head.querySelector('meta[name="echo-key"]');

if (echoKey) {

    echoKey = echoKey.getAttribute('content');

    let echo = new Echo({
        broadcaster: 'pusher',
        key: echoKey,
        cluster: 'ap2',
        encrypted: true
    });

    window.Echo = echo;

    window.publicChannel = echo.channel('all');

    let userMeta = document.head.querySelector('meta[name="current-user-id"]');

    if (userMeta) {
        let userId = userMeta.getAttribute('content');
        window.userChannel = echo.private('user.' + userId);
    }
}


require("./modules/app/app.module");


// WEBPACK FOOTER //
// ./resources/assets/bootstrap.js